<ng-container *transloco="let t;">
  <ng-container>
    <ul class="p-mb-4">
      <li *ngFor="let actual of candidates" [class.active]="candidate?.hashed_id === actual.candidate?.hashed_id">
        <app-avatar
          [user]="actual.candidate"
          [type]="'candidate'"
          [mode]="'small'"
          [inactive]="group !== null && !group.isLinkedToCandidate(actual.candidate.hashed_id, auth.getHashedId())"
        ></app-avatar>
        <strong *ngIf="candidate?.hashed_id === actual.candidate?.hashed_id">
          {{ actual.candidate?.fullname }}
        </strong>
        <a *ngIf="candidate?.hashed_id !== actual.candidate?.hashed_id" (click)="onChangeCandidate(actual)">
          {{ actual.candidate?.fullname }}
        </a>
      </li>
    </ul>
  </ng-container>
</ng-container>
